.add-certificate{display:flex;flex-direction:column;max-width:50rem}.add-certificate>*{width:100%}.form{display:flex}.modal-body{padding:2rem}.mat-mdc-form-field{width:100%}
/*# sourceMappingURL=add-carrier-certification.component-ADXQRROO.css.map */
